import "./Privacy.scss";

const Privacy = () => {
  return (
    <div className="privacy">
      <div className="privacy-line">
        <h1>Kebijakan Privasi</h1>
        <p className="last-updated">Terakhir diperbarui: Juli 2026</p>
        
        <h2>Informasi yang Kami Kumpulkan</h2>
        <p>
          Kami mengumpulkan informasi yang Anda berikan secara sukarela melalui form kontak atau WhatsApp, termasuk nama, nomor telepon, dan alamat email.
        </p>

        <h2>Penggunaan Informasi</h2>
        <p>
          Informasi Anda digunakan untuk menghubungi Anda terkait properti yang Anda minati, mengirimkan informasi promo, dan meningkatkan layanan kami.
        </p>

        <h2>Perlindungan Data</h2>
        <p>
          Kami menjaga keamanan data Anda dan tidak akan membagikan informasi pribadi Anda kepada pihak ketiga tanpa persetujuan Anda, kecuali diwajibkan oleh hukum.
        </p>

        <h2>Kontak</h2>
        <p>
          Jika ada pertanyaan mengenai kebijakan ini, hubungi kami melalui WhatsApp: +6281212356556
        </p>
      </div>
    </div>
  );
};

export default Privacy;
